import React from 'react';
import { SomeoneIsTyping } from '../live-updates-components';
import { unreachable } from '../../../ts-utils';
export function resolveSomeoneIsTyping(position, devOverride, someoneIsTyping) {
    switch (devOverride) {
        case 'off':
            return React.createElement(SomeoneIsTyping, { position: position, isTyping: false });
        case 'on':
            return React.createElement(SomeoneIsTyping, { position: position, isTyping: true });
        case 'auto':
            return someoneIsTyping !== 'none' ? (React.createElement(SomeoneIsTyping, { position: position, isTyping: someoneIsTyping === 'started' })) : null;
        default:
            unreachable(devOverride);
    }
    return null;
}
//# sourceMappingURL=resolve-someone-is-typing.js.map